<template>
  <div class="role-resources">
    <h3 class="role-resources__title">
      {{ 'role-resources.title-resources' | globalize }}
    </h3>
    <template v-for="(item, i) in roleDetails.permissions">
      <button
        v-ripple
        class="role-resources__btn app__button-flat"
        :class="{ 'app__button-flat--active': resource === item.resource}"
        :key="`role-${i}`"
        @click="$emit(EVENTS.setResource, item.resource)"
      >
        <h3>{{ item.resource }}</h3>
      </button>
    </template>
    <div class="role-resources__add-form">
      <permission-wrapper
        skip-alert
        page-name="roles"
        resource-name="role"
        action-name="update">
        <a-select
          v-if="resources.length > 0"
          :disabled="isDisabled"
          placeholder="Please select resource by click"
          class="role-resources-selector app-key-value__value"
          @change="onResourceChanged"
        >
          <a-select-option
            v-for="item in availableResources"
            :value="item"
            :key="`${item}`">
            {{ item }}
          </a-select-option>
        </a-select>

        <button
          v-ripple
          class="
            role-resources__btn-add
            app__button-raised"
          @click="isFormValid() && addResource()"
        >
          {{ 'role-resources.btn-add' | globalize }}
        </button>
      </permission-wrapper>
    </div>
  </div>
</template>

<script>
import RolesMixin from '@/vue/mixins/roles.mixin'
import _cloneDeep from 'lodash/cloneDeep'
import ASelect from 'ant-design-vue/lib/select'
import PermissionWrapper from '@/vue/common/permission-wrapper'

import { required } from '@validators'

const EVENTS = {
  setResource: 'set-resource',
  setRole: 'set-role',
}

export default {
  name: 'role-resources',
  components: {
    ASelect,
    'a-select-option': ASelect.Option,
    PermissionWrapper,
  },
  mixins: [ RolesMixin ],
  props: {
    resource: { type: String, default: '' },
  },
  data () {
    return {
      newResource: '',
      EVENTS,
    }
  },
  computed: {
    resourceExists () {
      return Boolean(this.roleDetails.permissions.find(item =>
        item.resource === this.newResource))
    },
    availableResources () {
      const result = []
      this.resources.forEach(a => {
        const found = this.roleDetails.permissions.find(o => {
          return o.permission === a
        })
        if (!found) {
          result.push(a)
        }
      })
      return result
    },
  },
  async created () {
    await this.loadResources()
  },
  validations: {
    newResource: { required },
  },
  methods: {
    addResource () {
      if (this.resourceExists) {
        return
      }

      let roleCopy = _cloneDeep(this.roleDetails)

      roleCopy.permissions.push({
        resource: this.newResource,
        actions: [],
      })

      this.$emit(EVENTS.setRole, roleCopy)
      this.$emit(EVENTS.setResource, this.newResource)
    },
    onResourceChanged (value) {
      this.newResource = value
    },
  },
}
</script>

<style lang="scss">
@import '~ant-design-vue/lib/select/style/index.css';

.role-resources {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.role-resources-selector {
  width: 100%;
}

.role-resources__title {
  margin-top: 2rem;
}

.role-resources__add-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.role-resources__btn-add {
  width: 100%;
}

.role-resources__btn-add-icon {
  font-size: 1.8rem;
  font-weight: 600;
}
</style>
